export default __webpack_public_path__ + "static/media/tesla.24deff49.png";